import { trackGAEvent } from '@/lib/ga-custom-events/dispatcher';
import { getFirstValidRouteWildcard } from '@/utils/navigation';
import { useSuspenseQuery } from '@apollo/client';
import {
  ComponentWildcardCta,
  FETCH_WILDCARDS_USER,
  FetchWildcardQuery,
  FetchWildcardQueryVariables,
  Wildcard,
} from '@edwin-group/cj-graphql';
import { startTransition, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const DailyCardWildcard = ({ setWildardsSize }: { setWildardsSize: (size: number) => void }) => {
  const navigate = useNavigate();
  const { data: wildcardsData } = useSuspenseQuery<FetchWildcardQuery, FetchWildcardQueryVariables>(
    FETCH_WILDCARDS_USER,
    {
      fetchPolicy: 'cache-and-network',
    },
  );

  const onClick = (wildcard: Wildcard | null) => {
    trackGAEvent('wildcard_interaction', {});
    navigate(getFirstValidRouteWildcard(wildcard?.cta as ComponentWildcardCta) || '/');
  };

  useEffect(() => {
    startTransition(() => {
      setWildardsSize(wildcardsData?.fetchWildcardUser?.length || 0);
    });
  }, [setWildardsSize, wildcardsData?.fetchWildcardUser?.length]);

  if (!wildcardsData?.fetchWildcardUser?.length) return null;

  return wildcardsData?.fetchWildcardUser?.map((wildcard) => (
    <div
      className="flex h-full flex-col items-center gap-sh-15 rounded-2xl bg-[#E67851] p-5 text-center"
      key={wildcard?.title || new Date().getTime()}>
      <h2 className=" text-center font-aTypeStencil text-sh-24-22 text-[#F1D55C]">{wildcard.title}</h2>
      <p className="font-cadiz text-sh-xxs text-white">{wildcard.description}</p>
      <button
        type="button"
        className="font-cadiz text-sh-xxs font-bold text-white hover:opacity-50"
        onClick={() => onClick(wildcard as Wildcard)}>
        {wildcard.ctaText}
      </button>
    </div>
  ));
};
